import * as React from "react"
import { cn } from "../utils/cn"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  /**
   * Si es true, muestra el estado de error (borde rojo)
   */
  error?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Base styles - matching current input appearance
          "flex w-full rounded-md border-2 bg-background px-4 py-3",
          "font-sans font-medium text-base",
          "outline-none transition-colors",
          "placeholder:text-muted-foreground",
          "disabled:cursor-not-allowed disabled:opacity-50",
          // Error state
          error
            ? "border-destructive focus:border-destructive"
            : "border-border focus:border-primary",
          className
        )}
        ref={ref}
        aria-invalid={error}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }

